var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('li',{class:{
        'active-single fw-600': _vm.model === _vm.value && _vm.labelModel !== '',
        'hover-li': _vm.index === _vm.value,
    },on:{"click":function($event){return _vm.selectOption()}}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.model === _vm.value && _vm.labelModel !== '' && _vm.multiple)?_c('i',{staticClass:"icon ion-md-checkmark float-right"}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }